import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsString } from 'class-validator';
import { LoyaltyProgramExposeGroupEnum } from '../interface';
export class CreateLoyaltyPromotionProviderDto {
}
__decorate([
    ApiProperty({
        type: () => String,
        description: 'toast specific pos_guid, it is used to bind our promotion to toast promotion',
        example: '039e63ef-03d1-4653-a341-4f493a70fcc3',
    }),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], CreateLoyaltyPromotionProviderDto.prototype, "pos_guid", void 0);
//# sourceMappingURL=CreateLoyaltyPromotionProviderDto.js.map